import { inject, Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core/auth/authentication.service';
import { ConfigurationService } from '@app/core/config/configuration.service';
import { SettingsService } from '@app/core/config/settings.service';

@Injectable()
export class AppInitService {
  private readonly configurationService = inject(ConfigurationService);
  private readonly authorizationService = inject(AuthenticationService);
  private readonly settingsService = inject(SettingsService);

  async init(): Promise<any> {
    await this.configurationService.load();
    await this.authorizationService.init();
    await this.settingsService.initSettings();
  }
}
